var _excluded = ["className", "dateFormat", "showTimezone", "rows", "saving", "saveLabel", "savingLabel"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import Button from "../Button/Button";
import ButtonToolbar from "../Button/ButtonToolbar";
import Card from "../Card/Card";
import CardBody from "../Card/CardBody";
import FormLabelGroup from "../Form/FormLabelGroup";
import Input from "../Input/Input";
import NoteHeader from "./NoteHeader";
export var EditableNoteDefaultProps = {
  className: 'bg-white mb-3',
  dateFormat: 'ddd, MMMM D, YYYY "at" h:mm A',
  showTimezone: true,
  rows: 4,
  saving: false,
  saveLabel: 'Save',
  savingLabel: 'Saving...'
};

var EditableNote = function EditableNote(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? EditableNoteDefaultProps.className : _ref$className,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? EditableNoteDefaultProps.dateFormat : _ref$dateFormat,
      _ref$showTimezone = _ref.showTimezone,
      showTimezone = _ref$showTimezone === void 0 ? EditableNoteDefaultProps.showTimezone : _ref$showTimezone,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? EditableNoteDefaultProps.rows : _ref$rows,
      _ref$saving = _ref.saving,
      saving = _ref$saving === void 0 ? EditableNoteDefaultProps.saving : _ref$saving,
      _ref$saveLabel = _ref.saveLabel,
      saveLabel = _ref$saveLabel === void 0 ? EditableNoteDefaultProps.saveLabel : _ref$saveLabel,
      _ref$savingLabel = _ref.savingLabel,
      savingLabel = _ref$savingLabel === void 0 ? EditableNoteDefaultProps.savingLabel : _ref$savingLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var children = props.children,
      note = props.note,
      onCancel = props.onCancel,
      _onChange = props.onChange,
      onSave = props.onSave;
  var errors = note.errors,
      text = note.text;
  return /*#__PURE__*/React.createElement(Card, {
    className: className
  }, /*#__PURE__*/React.createElement(NoteHeader, {
    note: note,
    dateFormat: dateFormat,
    showTimezone: showTimezone
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(FormLabelGroup, {
    feedback: errors,
    stacked: true
  }, /*#__PURE__*/React.createElement(Input, {
    autoFocus: true,
    className: "js-editable-note_text",
    disabled: saving,
    rows: rows,
    invalid: !!errors,
    type: "textarea",
    value: text,
    onChange: function onChange(event) {
      return _onChange(event, note);
    }
  })), children, /*#__PURE__*/React.createElement(ButtonToolbar, {
    className: "mt-3 mb-0"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "js-editable-note_save",
    color: "primary",
    disabled: saving,
    onClick: function onClick() {
      return onSave(note);
    }
  }, saving ? savingLabel : saveLabel), /*#__PURE__*/React.createElement(Button, {
    className: "js-editable-note_cancel",
    disabled: saving,
    onClick: function onClick() {
      return onCancel(note);
    }
  }, "Cancel"))));
};

EditableNote.displayName = "EditableNote";
EditableNote.defaultProps = {
  className: EditableNoteDefaultProps.className,
  dateFormat: EditableNoteDefaultProps.dateFormat,
  showTimezone: EditableNoteDefaultProps.showTimezone,
  rows: EditableNoteDefaultProps.rows,
  saving: EditableNoteDefaultProps.saving,
  saveLabel: EditableNoteDefaultProps.saveLabel,
  savingLabel: EditableNoteDefaultProps.savingLabel
};
EditableNote.displayName = 'EditableNote';
export default EditableNote;